import React from "react";
import HeaderFour from "../../components/Header/HeaderFour";
import VlogsMain from "./VlogsMain";
import Footer from "../../components/Footer";

const Vlogs = () => {
  return (
    <>
      <HeaderFour />
      <VlogsMain />
      <Footer />
    </>
  );
};

export default Vlogs;
